import { Direction } from 'radix-ui';
import type { ReactNode } from 'react';

/** Reading direction for all primitives (menus, sliders, keyboard arrows). Set once in App. */
export function DirectionProvider({ dir, children }: { dir: 'ltr' | 'rtl'; children: ReactNode }) {
  return <Direction.Provider dir={dir}>{children}</Direction.Provider>;
}
